import { useQueryClient } from '@tanstack/react-query';

import { useAuth } from '@/contexts/AuthContext';
import { createApiClient } from '@/shared/api/apiClient';
import type { components } from '@/shared/api/openapi';

type DistributorGroupInfo = components['schemas']['GetUserDistributorGroupDistributorInfoEndpoint_GetDistributorGroupInfoResponse'];

export function useDistributorGetDistributorGroupInfo() {
  const queryClient = useQueryClient();
  const { getAccessToken } = useAuth();

  const getDistributorGroupInfo = (organizationId: number, userId: string): Promise<DistributorGroupInfo | null> =>
    queryClient.fetchQuery({
      queryKey: ['distributor-group-distributor-info', organizationId, userId],
      queryFn: async () => {
        const client = createApiClient(getAccessToken);
        try {
          const { data } = await client.GET('/api/organizations/{organizationId}/users/distributor-group/distributor', {
            params: {
              path: { organizationId },
              query: { UserId: userId },
            },
          });
          return data ?? null;
        } catch (err) {
          if (err instanceof Error && err.message.startsWith('HTTP 404:')) {
            return null;
          }
          throw err;
        }
      },
    });

  return { getDistributorGroupInfo };
}
